import { stringToOption } from "./format";

/**
 * Get certificate area options based on asset ID
 * @param assetId - The asset ID to determine available areas
 * @returns Array of area options formatted for select components
 */
const CERTIFICATE_AREA_MAP: Record<number, string[]> = {
  21: ['Oil&Turret', 'Gas', 'Utilities', 'Marine', 'Chemical'],
  15: ['Oil', 'Gas', 'Utilities', 'Chemical', 'LOSAL'],
  38: ['Gas & Condensate', 'Utilities', 'Marine', 'Chemical'],
};

const DEFAULT_AREAS = ['Oil', 'Gas', 'Utilities', 'Chemical'];

export const getCertificateAreas = (assetId: number): string[] => {
  return CERTIFICATE_AREA_MAP[assetId] ?? DEFAULT_AREAS;
};

export const getCertificateAreaOptions = (assetId: number) => {
  const areas = CERTIFICATE_AREA_MAP[assetId] ?? DEFAULT_AREAS;
  return areas.map(stringToOption);
};

